import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../Typography";
const ThumbLabel = ({ value, measuringUnit, percentageForValue }) => {
    return (_jsx("div", { className: "-translate-x-1/2 absolute top-1/2 h-5 w-max translate-y-4 rounded bg-primary px-1 py-0.5", style: {
            left: `${percentageForValue}%`,
        }, children: _jsxs(Typography, { variant: "caption-medium", color: "white", children: [value, " ", measuringUnit] }) }));
};
export default ThumbLabel;
